import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import propTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddImagePreview from '../AddImage/AddImagePreview'
import AudioInput from '../AudioInput'
import Button from '../Button'
import ModalHeader from '../ModalHeader'
import { addImage as apiAddImage } from '../../api/books/images'
import { addBlockImage as apiAddBlockImage } from '../../api/books/blockImages'
import { addSound as apiAddSound } from '../../api/books/sounds'
import { addVideo as apiAddVideo } from '../../api/books/videos'
import { deleteImage } from '../../store/images/imageAction'
import { addSound, addSoundToCell } from '../../store/sounds/soundAction'
import { addVideo, deleteVideo } from '../../store/videos/videoAction'
import { updateBook } from '../../store/books/bookAction'
import './styles.scss'
import {
  pageTypeIsFree,
  pageTypeIsGrid,
  pageTypeIsNotFreeOrGrid,
  pageTypeIsQuestion,
} from '../../utils'
import { Form } from 'react-bootstrap'
import { toggleShowImages } from '../../store/images/imageAction'
import dayjs from 'dayjs'

const UploadFile = ({
  closeModal,
  text,
  type,
  chooseImage,
  setSource,
  cell,
  selectedBlockId,
}) => {
  const [isUploading, setIsUploading] = useState(false)
  const [showWarning, setShowWarning] = useState(false)
  const [warningText, setWarningText] = useState(null)
  const [showYoutubeWarning, setShowYoutubeWarning] = useState(false)
  const [youtubeWarningText, setYoutubeWarningText] = useState(null)
  const [shownImages, setShownImages] = useState(null)
  const [file, setFile] = useState(null)
  const [showRecorder, setShowRecorder] = useState(false)
  const [chosenImage, setChosenImage] = useState(null)
  const [openCardModal, setOpenCardModal] = useState(false)
  const [percentageDownloaded, setPercentageDownloaded] = useState(0)
  const [youtubeUrl, setYoutubeUrl] = useState('')
  const images = useSelector((state) => state.images.images)
  const blockImages = useSelector((state) => state.blockImages.images)
  const currentBookId = useSelector((state) => state.books.currentBook)
  const currentBook = useSelector((state) => state.books.books[currentBookId])
  const book = useSelector((state) => state.books.books[currentBookId])
  const currentPageId = useSelector((state) => state.pages.currentPage)
  const currentPage = useSelector((state) => state.pages.pages[currentPageId])
  const allowMultipleVideosOnPage =
    pageTypeIsFree(currentPage?.type) || pageTypeIsQuestion(currentPage?.type)
  const user = useSelector((state) => state.user)
  const showAllImages = useSelector((state) => state.images.showAll)
  const dispatch = useDispatch()

  const inputRef = useRef()
  const uploadNowRef = useRef()
  const handleClick = () => {
    inputRef.current.click()
  }

  const previewImage = (result) => {
    setOpenCardModal(true)
    let url = result.url
    if (result.type === 0) {
      setChosenImage({ ...result, url: url })
    }
    setChosenImage(result)
  }

  const sortImagesByUpdateTimestamp = (a, b) => {
    const timeInMillisecondsA = dayjs(a.updated).valueOf()
    const timeInMillisecondsB = dayjs(b.updated).valueOf()
    return timeInMillisecondsB - timeInMillisecondsA
  }

  const removeDuplicatesAndKuhaImages = (list) => {
    let filenames = []
    let ids = []
    Object.values(list)
      .filter(
        (i) =>
          i.filename !== '//:0' &&
          i.filename.includes('https://kuha.papunet.net') === false
      )
      .forEach((img) => {
        if (filenames.indexOf(img.filename) === -1) {
          filenames.push(img.filename)
          ids.push(img.id)
        }
      })
    setShownImages(list.filter((img) => ids.includes(img.id)))
  }

  const maxFileSize = 5.5 * 1024 * 1024 // 5 Mt ja vähän päälle varmuuden vuoksi

  useEffect(() => {
    if (file && uploadNowRef && uploadNowRef.current) {
      if (file.name.indexOf('.svg') === -1) {
        uploadNowRef.current.click()
      } else {
        setShowWarning(true)
        setWarningText('Kielletty tiedostomuoto.')
      }
    }
  }, [file, uploadNowRef])

  const uploadFile = async (e) => {
    e.preventDefault()
    let source = axios.CancelToken.source()
    const config = {
      cancelToken: source.token,
      onUploadProgress: (progressEvent) =>
        setPercentageDownloaded(
          Math.round((progressEvent.loaded / progressEvent.total) * 100)
        ),
    }
    if (setSource) setSource(source)
    setShowWarning(false)
    const data = new FormData()
    data.append('file', file)
    if (file.size > maxFileSize) {
      setShowWarning(true)
      setWarningText(`Tiedostosi on liian suuri. Maksimikoko on 5 Mt.`)
      return
    } else {
      if (file.type.indexOf('audio') !== -1) {
        try {
          setIsUploading(true)
          apiAddSound(data, config)
            .then((res) => {
              const newSound = {
                id: res.data.id,
                pageId: currentPageId,
                userId: user.id,
                draggable: cell ? 0 : 1,
                filename: res.data.filename,
                x: 0,
                y: 0,
              }
              if (cell) {
                dispatch(addSoundToCell(newSound, cell))
              } else {
                dispatch(addSound(newSound))
              }
              const updatedBook = {
                ...book,
                updated: Date.now(),
              }
              dispatch(updateBook(updatedBook))
              closeModal()
            })
            .then(() => {
              setIsUploading(false)
            })
        } catch (error) {
          setShowWarning(true)
          setWarningText('Tiedostoa ei voitu ladata.')
        }
      } else if (file.type.indexOf('video') !== -1) {
        try {
          setIsUploading(true)
          if (
            !allowMultipleVideosOnPage &&
            currentPage.videos &&
            currentPage.videos.length > 0
          ) {
            dispatch(deleteVideo(currentPage.videos[0]))
          }
          apiAddVideo(data, config).then((res) => {
            const newVideo = {
              pageId: currentPageId,
              userId: user.id,
              filename: res.data.filename,
              width: res.data.width,
              height: res.data.height,
              type: 1,
            }
            dispatch(addVideo(newVideo))
            if (
              res &&
              pageTypeIsNotFreeOrGrid(currentPage.type) &&
              currentPage.images.length > 0
            ) {
              dispatch(deleteImage(currentPage.images[0]))
            }
            const updatedBook = {
              ...book,
              updated: Date.now(),
            }
            dispatch(updateBook(updatedBook))
            closeModal()
          })
        } catch (error) {
          setShowWarning(true)
        }
      } else {
        if (selectedBlockId !== undefined) {
          apiAddBlockImage(data).then((res) => {
            setChosenImage(res.data)
            setOpenCardModal(true)
          })
        } else {
          apiAddImage(data).then((res) => {
            setChosenImage(res.data)
            setOpenCardModal(true)
          })
        }
      }
    }
  }

  const uploadYoutubeVideo = async (inputUrl) => {
    try {
      setIsUploading(true)
      if (
        !allowMultipleVideosOnPage &&
        currentPage?.videos &&
        currentPage.videos.length > 0
      ) {
        await dispatch(deleteVideo(currentPage.videos[0]))
      }
      const newVideo = {
        pageId: currentPageId,
        userId: user.id,
        filename: inputUrl,
        width: 560,
        height: 315,
        type: 1,
      }
      dispatch(addVideo(newVideo))
      if (
        pageTypeIsNotFreeOrGrid(currentPage.type) &&
        currentPage.images.length > 0
      ) {
        dispatch(deleteImage(currentPage.images[0]))
      }
      const updatedBook = {
        ...book,
        updated: Date.now(),
      }
      dispatch(updateBook(updatedBook))
      closeModal()
    } catch (error) {
      setShowWarning(true)
    }
  }

  const getAcceptedFileTypes = () => {
    if (type === 'video') {
      return 'video/*'
    } else if (type === 'audio') {
      return 'audio/*, audio/mp3, audio/wav'
    }
    return 'image/*'
  }

  const getHeaderText = () => {
    if (type === 'audio') {
      return 'Lisää ääni'
    } else if (type === 'video') {
      return 'Lataa video'
    }
    return ''
  }

  const addRecordedAudio = (file) => {
    setShowWarning(false)
    const data = new FormData()
    data.append('file', file)
    let source = axios.CancelToken.source()
    const config = {
      cancelToken: source.token,
      onUploadProgress: (progressEvent) =>
        setPercentageDownloaded(
          Math.round((progressEvent.loaded / progressEvent.total) * 100)
        ),
    }
    if (setSource) setSource(source)

    try {
      setIsUploading(true)
      apiAddSound(data, config).then((res) => {
        const newSound = {
          id: res.data.id,
          pageId: currentPageId,
          userId: user.id,
          draggable: cell ? 0 : 1,
          filename: res.data.filename,
          x: 0,
          y: 0,
        }
        if (cell) {
          dispatch(addSoundToCell(newSound, cell))
        } else {
          dispatch(addSound(newSound))
        }

        const updatedBook = {
          ...book,
          updated: Date.now(),
        }
        dispatch(updateBook(updatedBook))
        closeModal()
      })
    } catch (error) {
      setShowWarning(true)
      setWarningText('Tiedostoa ei voitu ladata.')
    }
  }

  useEffect(() => {
    if (images && blockImages) {
      const combinedImages = Object.values(images).concat(Object.values(blockImages))
      const list = combinedImages
        .sort((a, b) => sortImagesByUpdateTimestamp(a, b))
        .filter((img) =>
          showAllImages ? true : currentBook.pages.includes(img.pageId)
        )
        .slice(0, 51)
      removeDuplicatesAndKuhaImages(list)
    }
  }, [currentBook, images, showAllImages])

  const handleAuthorClick = (img) => {
    if (!img?.author) {
      window.alert('Kuvan tekijätieto puuttuu.')
    } else {
      navigator.clipboard.writeText(img.author)
      window.alert('Kuvan tekijätieto kopioitu leikepöydälle.')
    }
  }

  const cleanYoutubeUrl = (url) => {
    try {
      const trimmedUrl = url.trim()
      let cleanUrl = trimmedUrl

      // Käsitellään youtube.com/watch?v= muotoiset URL:t
      if (trimmedUrl.includes('youtube.com/watch')) {
        const urlObj = new URL(trimmedUrl)
        const videoId = urlObj.searchParams.get('v')
        const timestamp = urlObj.searchParams.get('t')

        if (videoId) {
          cleanUrl = `https://www.youtube.com/watch?v=${videoId}`
          if (timestamp) {
            cleanUrl += `&t=${timestamp}`
          }
        }
      }
      // Käsitellään youtu.be/ muotoiset URL:t
      else if (trimmedUrl.includes('youtu.be/')) {
        const urlObj = new URL(trimmedUrl)
        const videoId = urlObj.pathname.split('/').filter(Boolean)[0]
        const timestamp = urlObj.searchParams.get('t')

        if (videoId) {
          cleanUrl = `https://www.youtube.com/watch?v=${videoId}`
          if (timestamp) {
            cleanUrl += `&t=${timestamp}`
          }
        }
      }

      return cleanUrl
    } catch (error) {
      return url.trim()
    }
  }

  const handleYoutubeVideoSubmit = () => {
    if (youtubeUrl.trim() === '') {
      setShowYoutubeWarning(true)
      setYoutubeWarningText('Youtube-videon URL ei voi olla tyhjä.')
      return
    }
    if (
      !youtubeUrl.includes('youtube.com/watch?v=') &&
      !youtubeUrl.includes('youtu.be/')
    ) {
      setShowYoutubeWarning(true)
      setYoutubeWarningText('Youtube-videon URL ei ole kelvollinen.')
      return
    }
    const cleanedUrl = cleanYoutubeUrl(youtubeUrl)
    uploadYoutubeVideo(cleanedUrl)
  }

  return (
    <div
      className={
        type !== 'image'
          ? 'file-upload-container'
          : 'file-upload-container margin-top-container'
      }
    >
      {isUploading ? (
        <div className="spinner-content">
          <FontAwesomeIcon icon="spinner" spin className="spinner-icon" />
          <p style={{ textAlign: 'center' }}>
            {' '}
            {percentageDownloaded === 100
              ? 'Muunnetaan tiedosto web-muotoon, odota...'
              : 'Ladataan...'}
          </p>
          <div className="progressbar">
            <span
              className="progressbar-block"
              style={{
                height: '24px',
                width: percentageDownloaded + '%',
              }}
            />
          </div>
          <p style={{ textAlign: 'center' }}>{percentageDownloaded}%</p>
          <Button
            className="dialogue-button gray-button single-button"
            onClick={closeModal}
            type="button"
            style="margin: 0"
          >
            Peruuta
          </Button>
        </div>
      ) : (
        <>
          {(type === 'audio' || type === 'video') &&
            !pageTypeIsGrid(currentPage.type) && (
              <ModalHeader headerText={getHeaderText()} onClick={closeModal} />
            )}

          {type === 'video' && (
            <div className="upload-video-yt-container">
              <h2 className="modal-h2">Upota Youtube-video</h2>
              <label htmlFor="youtube-url" className="yt-modal-label">
                Youtube-videon verkko-osoite (URL):
              </label>
              <input
                type="text"
                id="youtube-url"
                name="youtube-url"
                className="yt-modal-input"
                value={youtubeUrl}
                onChange={(e) => setYoutubeUrl(e.target.value)}
              />
              {showYoutubeWarning ? (
                <p className="red-text">{youtubeWarningText}</p>
              ) : (
                <></>
              )}
              <Button
                className="dialogue-button select-button single-button"
                style="margin-bottom:20px"
                onClick={() => handleYoutubeVideoSubmit()}
                type="button"
              >
                Upota video
              </Button>
              <h2 className="modal-h2">Tuo video omalta laitteelta</h2>
            </div>
          )}
          {type === 'audio' && (
            <p>
              Äänitä tai lataa äänitiedosto omalta koneelta. Äänitiedosto ei saa olla
              tiedostokooltaan liian suuri. Maksimikoko on 5 Mt.
            </p>
          )}
          {!showRecorder && type === 'audio' && (
            <Button
              className="record-audio-button"
              onClick={() => setShowRecorder(true)}
              role="link"
            >
              <FontAwesomeIcon aria-hidden icon="microphone" size="2x" />
              <p className="sr-only">Äänitä</p>
            </Button>
          )}
          {showRecorder && (
            <AudioInput
              handleSubmit={(file) => addRecordedAudio(file)}
              setShowRecorder={setShowRecorder}
              showAudioModal={showRecorder}
            />
          )}
          {!showRecorder &&
            text.map((content, index) => <p key={index}>{content}</p>)}
          {!showRecorder && (
            <div className="centered-button-container">
              <Button
                className="dialogue-button select-button single-button"
                onClick={handleClick}
                type="button"
              >
                Valitse tiedosto
              </Button>
              {/*(type === 'audio' || type === 'video') && (
                <Button
                  className="dialogue-button gray-button"
                  onClick={closeModal}
                  type="button"
                >
                  Sulje
                </Button>
              )*/}
            </div>
          )}
          <form onSubmit={uploadFile} encType="multipart/form-data">
            <input
              type="file"
              name="file"
              ref={inputRef}
              accept={getAcceptedFileTypes()}
              hidden
              onChange={(e) => setFile(e.target.files[0])}
            />
            <input type="submit" value="Upload Now" hidden ref={uploadNowRef} />
          </form>
          {showWarning ? <p className="red-text">{warningText}</p> : <></>}
          {type === 'image' && (
            <>
              <Form
                className="search-buttons-container add-margins"
                style={{ margin: '0 0 10px auto' }}
              >
                <Form.Check
                  type="checkbox"
                  id="custom-checkbox"
                  label="Näytä vain muokkaustilassa olevan kirjan kuvat"
                  checked={!showAllImages}
                  onChange={() => dispatch(toggleShowImages(!showAllImages))}
                />
              </Form>
              <div className="image-results-container">
                {shownImages &&
                  shownImages.map((image) => {
                    return (
                      <Button
                        key={image.id}
                        className="choose-image-button"
                        onClick={() => previewImage(image)}
                      >
                        <img
                          src={image.filename}
                          alt={image.alt}
                          width={image.width < image.height ? 'auto' : '100%'}
                          height="auto"
                          draggable="false"
                          className="image-result"
                        />
                        <div
                          className="list-image-author"
                          role="button"
                          onClick={(e) => {
                            e.stopPropagation()
                            handleAuthorClick(image)
                          }}
                          tabIndex="0"
                          aria-label={image.author || ''}
                          title={image.author || ''}
                          hidden={!image.author}
                        >
                          <FontAwesomeIcon icon={['fas', 'info-circle']} />
                        </div>
                      </Button>
                    )
                  })}
              </div>
            </>
          )}
        </>
      )}
      {openCardModal && chosenImage && (
        <AddImagePreview
          openCardModal={openCardModal}
          setOpenCardModal={setOpenCardModal}
          closeModal={closeModal}
          result={chosenImage}
          chooseImage={chooseImage}
        />
      )}
    </div>
  )
}

UploadFile.propTypes = {
  closeModal: propTypes.func.isRequired,
  text: propTypes.instanceOf(Array).isRequired,
  type: propTypes.string,
  chooseImage: propTypes.func,
  setSource: propTypes.func,
  cell: propTypes.instanceOf(Object),
  selectedBlockId: propTypes.number,
}

UploadFile.defaultProps = {
  type: 'image',
  chooseImage: null,
  setSource: null,
  cell: null,
}

export default UploadFile
